import { render, staticRenderFns } from "./remittancepayable.vue?vue&type=template&id=b46f4226&scoped=true"
import script from "./remittancepayable.vue?vue&type=script&lang=js"
export * from "./remittancepayable.vue?vue&type=script&lang=js"
import style0 from "./remittancepayable.vue?vue&type=style&index=0&id=b46f4226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b46f4226",
  null
  
)

export default component.exports